export interface Theme {
  theme: string;
  text_color: string;
}

export const defaultTheme = {
  theme: '#c2d216',
  text_color: '#d32f2f'

}

export interface ThemeColorsPayload {
  theme_color: string;
  text_color: string;
}